import React from "react";

const IconPaperclip = ({
  width = 20,
  height = 20,
  viewBox = "0 0 20 20",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1279_6334)">
      <path
        d="M17.8667 9.20838L10.2084 16.8667C9.27017 17.8049 7.99769 18.332 6.67087 18.332C5.34405 18.332 4.07157 17.8049 3.13337 16.8667C2.19517 15.9285 1.66809 14.656 1.66809 13.3292C1.66809 12.0024 2.19517 10.7299 3.13337 9.79171L10.7917 2.13338C11.4172 1.50791 12.2655 1.15652 13.15 1.15652C14.0346 1.15652 14.8829 1.50791 15.5084 2.13338C16.1338 2.75885 16.4852 3.60716 16.4852 4.49171C16.4852 5.37626 16.1338 6.22458 15.5084 6.85005L7.8417 14.5084C7.52897 14.8211 7.10481 14.9968 6.66254 14.9968C6.22026 14.9968 5.79611 14.8211 5.48337 14.5084C5.17064 14.1956 4.99494 13.7715 4.99494 13.3292C4.99494 12.8869 5.17064 12.4628 5.48337 12.15L12.5584 5.08338"
        stroke="#424242"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1279_6334">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconPaperclip;
